import { BusinessReportPostRequest } from './BusinessReportPostRequest';

export interface BusinessReportAddRow extends BusinessReportPostRequest {
  id: string;
  manHoursCategory: 'A' | 'B' | 'C' | 'D' | 'E' | '';
}

export type BusinessReportAddRowsArray = BusinessReportAddRow[];

export const EmptyBusinessReportAddRow: BusinessReportAddRow = {
  id: '',
  date: '',
  projectId: null,
  manHoursCategory: '',
  manHoursA: false,
  manHoursB: false,
  manHoursC: false,
  manHoursD: false,
  manHoursE: false,
  startTime: null,
  endTime: null,
  manHoursTotal: 0,
};

export const EmptyBusinessReportAddRowsArray: BusinessReportAddRowsArray = [
  EmptyBusinessReportAddRow,
];
